<template>
    <div class="f3 footerLinklist container">
        <MenuList :key="buildKey(section)" :menuList="section" v-for="section in contentData"/>
    </div>
</template>

<script>
    import MenuList from './MenuList.vue';

    export default {
    components: { MenuList },
    props: ['contentData'],
    methods: {
      buildKey(section) {
        return section.title.replace(/[\W_]+/g, '');
      },
    },
  };
</script>
